import { render, staticRenderFns } from "./nav-header-sm.vue?vue&type=template&id=080fe599&scoped=true"
import script from "./nav-header-sm.vue?vue&type=script&lang=js"
export * from "./nav-header-sm.vue?vue&type=script&lang=js"
import style0 from "./nav-header-sm.vue?vue&type=style&index=0&id=080fe599&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080fe599",
  null
  
)

export default component.exports